import styled from "@emotion/styled"
import { FlexContainer, FlexContainerAndItem } from "../../../styled/flexbox.styled"
import { EditableText, Switch } from "@blueprintjs/core"

export const DatavizContainer = styled(FlexContainer)({
  gridArea: "content",
  height: "100%",
  width: "100%",
  padding: "15px",
})

export const BottomContainer = styled(FlexContainerAndItem)({
  width: "100%",
})

export const StyledEditableText = styled(EditableText)({
  width: "200px",
  minWidth: "200px",
  textAlign: "center",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
})

export const StyledSwitch = styled(Switch)({
  margin: 0,
  padding: 0,
  height: "20px",
  display: "inline-flex",
  alignItems: "center",
  flexDirection: "row-reverse",
  ".bp3-control-indicator": {
    margin: 0,
    marginLeft: "7px",
    order: 2,
  },
  "&.bp3-switch": {
    marginBottom: 0,
  },
  ".bp3-switch-inner-text": {
    height: "20px",
    lineHeight: "20px",
    order: 1,
  },
})
